import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/trader/[address]/position/[positionId]/page.tsx");
